var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58484",
    "data-name": "Group 58484",
    transform: "translate(-1152 -434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle-xmark_1_",
    "data-name": "circle-xmark (1)",
    d: "M16,8A8,8,0,1,1,8,0,8.009,8.009,0,0,1,16,8Z",
    transform: "translate(1152 434)",
    fill: "#f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle-xmark_1_2",
    "data-name": "circle-xmark (1)",
    d: "M10.471,6.471,8.943,8l1.529,1.529a.667.667,0,1,1-.943.943L8,8.943,6.471,10.471a.667.667,0,1,1-.943-.943L7.057,8,5.529,6.471a.667.667,0,0,1,.943-.943L8,7.057,9.529,5.529a.667.667,0,1,1,.943.943Z",
    transform: "translate(1152 434)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.fce71da1d44eb66b3dcdf0bbfd594241.svg";
export { ForwardRef as ReactComponent };